import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { services } from "../data/mockData";
import { CarteService } from "./CarteService";

export const Services = () => (
  <section id="services" className="section">
    <div className="shell">
      <div className="mx-auto max-w-[840px] text-center">
        <h2 className="h2">
          Six façons de <em>travailler ensemble</em>
        </h2>
        <p className="lede mt-6">
          De l'automatisation au développement sur mesure, en passant par la
          sous-traitance de vos travaux de saisie et de collecte.
        </p>
      </div>

      <div className="mt-10 lg:mt-12 grid gap-6 md:grid-cols-2 xl:grid-cols-3">
        {services.map((service) => (
          <CarteService key={service.id} service={service} />
        ))}
      </div>

      <div className="mt-10 flex flex-wrap justify-center gap-4">
        <Link to="/#contact" className="btn-accent">
          Décrire votre besoin
          <ArrowRight className="h-5 w-5" strokeWidth={2.4} aria-hidden="true" />
        </Link>
        <Link to="/services" className="btn-outline">
          Tous nos services
        </Link>
      </div>
    </div>
  </section>
);
